import { render } from "./ViewTourCollectionWelcome.vue?vue&type=template&id=5ac5bc7a&scoped=true"
import script from "./ViewTourCollectionWelcome.vue?vue&type=script&lang=ts"
export * from "./ViewTourCollectionWelcome.vue?vue&type=script&lang=ts"

import "./ViewTourCollectionWelcome.vue?vue&type=style&index=0&id=5ac5bc7a&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-5ac5bc7a"

export default script